export class CurrentClass {
  groupId: number;
  className: string;
  additionalInfo: CurrentClassAdditional;

  constructor(groupId: number, className: string, classAdditionalInfo: CurrentClassAdditional) {
    this.groupId = groupId;
    this.className = className;
    this.additionalInfo = classAdditionalInfo;
  }
}

export class CurrentClassAdditional {
  title: string;
  lesson: string;
  lessonId: number;
  topic: string;
  requestId: number;
  uiVersion: number;


  constructor(title: string, lesson: string, lessonId?: number, topic?: string, uiVersion?: number, requestId?: number) {
    this.title = title;
    this.lesson = lesson;
    this.lessonId = lessonId;
    this.topic = topic;
    this.requestId = requestId;
    this.uiVersion = uiVersion;
  }
}
